import {P} from "Core/Common/Promise";
import {Request, IRequestOptions} from "Core/Common/Request";

export interface IHistoryRequestModel {
	EntityId: number;
	RecordId: number;
}

export interface IGetTableHistoryRequestModel {
	EntityId: number;
	RecordId: number;
	TableId: number;
	RecordSelectionId?: number;
}

export interface IHistoryRecordOption {
	RecordId: number;
	Name: string;
}

export interface IHistoryTableOption {
	TableId: number;
	Name: string;
	Group: string;
	IsMain: boolean;
}

export interface IHistoryFieldChange {
	FieldName: string;
	OldValue: string;
	NewValue: string;
	Type: string;
	Format: string;
	Sort: number;
}

export interface IHistoryOperation {
	OperationId: string;
	ChangeDate: string;
	OperationTypeId: number;
	OperationName: string;
	OperationKind: string;
	ChangedBy: string;
	FieldCount: number;
	Fields: IHistoryFieldChange[];
}

export class HistoryLogsStore {

	static GetHistory(model: IHistoryRequestModel): P.Promise<any> {
		let deferredResult = P.defer<any>();

		let requestParams: IRequestOptions = {
			proxy: {
				url: 'api/HistoryApi/GetHistory',
				dataType: 'json',
				type: 'GET'
			}, params: model
		};

		Request.Send(requestParams)
			.then(data => deferredResult.resolve(data));

		return deferredResult.promise();
	}

	static HasHistory(model: IHistoryRequestModel): P.Promise<boolean> {
		let deferredResult = P.defer<any>();

		let requestParams: IRequestOptions = {
			proxy: {
				url: 'api/HistoryApi/HasHistory',
				dataType: 'json',
				type: 'GET'
			}, params: model
		};

		Request.Send(requestParams)
			.then(data => {
					deferredResult.resolve(data)
				}
			);

		return deferredResult.promise();
	}

	static GetHistoryTables(model: IHistoryRequestModel): P.Promise<any> {
		let deferredResult = P.defer<any>();

		let requestParams: IRequestOptions = {
			proxy: {
				url: 'api/HistoryApi/GetHistoryTables',
				dataType: 'json',
				type: 'GET'
			}, params: model
		};

		Request.Send(requestParams)
			.then(data => deferredResult.resolve(data))
			.fail(err => deferredResult.reject(err));

		return deferredResult.promise();
	}

	static GetTableHistory(model: IGetTableHistoryRequestModel): P.Promise<any> {
		let deferredResult = P.defer<any>();

		let requestParams: IRequestOptions = {
			proxy: {
				url: 'api/HistoryApi/GetTableHistory',
				dataType: 'json',
				type: 'GET'
			}, params: model
		};

		Request.Send(requestParams)
			.then(data => deferredResult.resolve(data))
			.fail(err => deferredResult.reject(err));

		return deferredResult.promise();
	}

	static GetTableRecords(model: IGetTableHistoryRequestModel): P.Promise<any> {
		let deferredResult = P.defer<any>();

		let requestParams: IRequestOptions = {
			proxy: {
				url: 'api/HistoryApi/GetTableRecords',
				dataType: 'json',
				type: 'GET'
			}, params: model
		};

		Request.Send(requestParams)
			.then(data => deferredResult.resolve(data))
			.fail(err => deferredResult.reject(err));

		return deferredResult.promise();
	}
}
